// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingGenericListPanel_root__21Klu","form":"EditListingGenericListPanel_form__2SIgZ","title":"EditListingGenericListPanel_title__1wegz"};